import { useState } from 'react';
import { useDebounce } from '@uidotdev/usehooks';
import _ from 'lodash';
import useSWR from 'swr';
import { getFirstBoardItemsPage } from '@gorilla/common/src/lib/monday-api/api';
import { transformBoardFiltersToGraphQL } from '@gorilla/common/src/lib/rules';
import { useItem } from './use-item';
import { mondayClient } from '../../services/monday';

export function useItemPicker({ boardId, selectedItemId }: { boardId: number | null; selectedItemId?: number }) {
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const searchTermDeferred = useDebounce(searchTerm, 200);

  const {
    data: searchItems,
    error: itemsError,
    isLoading: isLoadingItems,
  } = useSWR(
    boardId ? `/item-search/${boardId}/${searchTermDeferred || ''}` : null,
    async () => {
      let queryParams;

      if (searchTermDeferred) {
        queryParams = transformBoardFiltersToGraphQL({
          rules: [{ column_id: 'name', operator: 'contains_text', compare_value: [{ id: 'text', value: searchTermDeferred }] }],
        });
      }

      return (await getFirstBoardItemsPage(mondayClient, boardId!, 10, queryParams)).items;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  const { item: selectedItem, error: selectedItemError, isLoading: isSelectedItemLoading } = useItem(selectedItemId);
  const items = _.unionBy([...(searchItems || []), ...(selectedItem ? [selectedItem] : [])], 'id');
  const isLoading = isLoadingItems || isSelectedItemLoading;

  return {
    items,
    itemsError,
    selectedItemError,
    isLoading,
    setSearchTerm,
  };
}
